var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-empty',{attrs:{"description":_vm.desc}},[_c('img',{staticClass:"err-img",attrs:{"slot":"image","src":require("img/err.png")},slot:"image"})])
}
var staticRenderFns = []

export { render, staticRenderFns }